import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { address: '_commonAddress' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _barcodeDisplay = { expirationDate: 'google.protobuf.Timestamp' };
var _captureChargeRequest = {};
var _captureChargeResponse = { charge: '_charge' };
var _charge = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fulfillmentDate: 'google.protobuf.Timestamp',
    barcodeDisplay: '_barcodeDisplay',
    qrCodeDisplay: '_qrCodeDisplay',
    webPageDisplay: '_webPageDisplay',
    items: '_item',
    billingInfo: '_address',
    shippingInfo: '_address',
};
var _commonAddress = { geocode: '_addressLocation' };
var _createChargeRequest = { charge: '_charge' };
var _createChargeResponse = { charge: '_charge' };
var _getChargeRequest = {};
var _getChargeResponse = { charge: '_charge' };
var _item = { weightInKg: 'google.protobuf.DoubleValue' };
var _qrCodeDisplay = { expirationDate: 'google.protobuf.Timestamp' };
var _queryChargesRequest = {};
var _queryChargesResponse = { charges: '_charge' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = { charge: '_charge' };
var _voidChargeRequest = {};
var _voidChargeResponse = { charge: '_charge' };
var _webPageDisplay = { expirationDate: 'google.protobuf.Timestamp' };
function resolveWixPaymentsChargesV1ChargeServiceUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function createCharge(payload) {
    var _a = serializer(_createChargeRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _barcodeDisplay: _barcodeDisplay,
        _charge: _charge,
        _commonAddress: _commonAddress,
        _item: _item,
        _qrCodeDisplay: _qrCodeDisplay,
        _webPageDisplay: _webPageDisplay,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createChargeResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _barcodeDisplay: _barcodeDisplay,
        _charge: _charge,
        _commonAddress: _commonAddress,
        _item: _item,
        _qrCodeDisplay: _qrCodeDisplay,
        _webPageDisplay: _webPageDisplay,
    }).fromJSON;
    function __createCharge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.charges.v1.charge',
            method: 'POST',
            methodFqn: 'wix.payments.charges.v1.ChargeService.CreateCharge',
            url: resolveWixPaymentsChargesV1ChargeServiceUrl({
                protoPath: '/v1/charges',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCharge.fromReq = fromReq;
    __createCharge.__isAmbassador = true;
    return __createCharge;
}
export function getCharge(payload) {
    var _a = serializer(_getChargeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getChargeResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _barcodeDisplay: _barcodeDisplay,
        _charge: _charge,
        _commonAddress: _commonAddress,
        _item: _item,
        _qrCodeDisplay: _qrCodeDisplay,
        _webPageDisplay: _webPageDisplay,
    }).fromJSON;
    function __getCharge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.charges.v1.charge',
            method: 'GET',
            methodFqn: 'wix.payments.charges.v1.ChargeService.GetCharge',
            url: resolveWixPaymentsChargesV1ChargeServiceUrl({
                protoPath: '/v1/charges/{chargeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCharge.fromReq = fromReq;
    __getCharge.__isAmbassador = true;
    return __getCharge;
}
export function queryCharges(payload) {
    var _a = serializer(_queryChargesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryChargesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _barcodeDisplay: _barcodeDisplay,
        _charge: _charge,
        _commonAddress: _commonAddress,
        _item: _item,
        _qrCodeDisplay: _qrCodeDisplay,
        _webPageDisplay: _webPageDisplay,
    }).fromJSON;
    function __queryCharges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.charges.v1.charge',
            method: 'POST',
            methodFqn: 'wix.payments.charges.v1.ChargeService.QueryCharges',
            url: resolveWixPaymentsChargesV1ChargeServiceUrl({
                protoPath: '/v1/charges/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCharges.fromReq = fromReq;
    __queryCharges.__isAmbassador = true;
    return __queryCharges;
}
/** todo: should it be here ??? */
export function voidCharge(payload) {
    var _a = serializer(_voidChargeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_voidChargeResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _barcodeDisplay: _barcodeDisplay,
        _charge: _charge,
        _commonAddress: _commonAddress,
        _item: _item,
        _qrCodeDisplay: _qrCodeDisplay,
        _webPageDisplay: _webPageDisplay,
    }).fromJSON;
    function __voidCharge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.charges.v1.charge',
            method: 'POST',
            methodFqn: 'wix.payments.charges.v1.ChargeService.VoidCharge',
            url: resolveWixPaymentsChargesV1ChargeServiceUrl({
                protoPath: '/v1/charges/{chargeId}/void',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __voidCharge.fromReq = fromReq;
    __voidCharge.__isAmbassador = true;
    return __voidCharge;
}
export function captureCharge(payload) {
    var _a = serializer(_captureChargeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_captureChargeResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _barcodeDisplay: _barcodeDisplay,
        _charge: _charge,
        _commonAddress: _commonAddress,
        _item: _item,
        _qrCodeDisplay: _qrCodeDisplay,
        _webPageDisplay: _webPageDisplay,
    }).fromJSON;
    function __captureCharge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.charges.v1.charge',
            method: 'POST',
            methodFqn: 'wix.payments.charges.v1.ChargeService.CaptureCharge',
            url: resolveWixPaymentsChargesV1ChargeServiceUrl({
                protoPath: '/v1/charges/{chargeId}/capture',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __captureCharge.fromReq = fromReq;
    __captureCharge.__isAmbassador = true;
    return __captureCharge;
}
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _barcodeDisplay: _barcodeDisplay,
        _charge: _charge,
        _commonAddress: _commonAddress,
        _item: _item,
        _qrCodeDisplay: _qrCodeDisplay,
        _webPageDisplay: _webPageDisplay,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.charges.v1.charge',
            method: 'POST',
            methodFqn: 'wix.payments.charges.v1.ChargeService.UpdateExtendedFields',
            url: resolveWixPaymentsChargesV1ChargeServiceUrl({
                protoPath: '/v1/charges/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
//# sourceMappingURL=http.impl.js.map